import Immutable from 'immutable';
import moment from 'moment';
import React from 'react';
import TableAction from 'sharedreact/components/TableAction';

import TableActions from 'sharedreact/components/TableActions';
import TableContainer from 'sharedreact/containers/TableContainer';
import SortOrder from 'sharedreact/data/SortOrder';
import type TableColumn from 'sharedreact/data/TableColumn';
import type { RangeType } from 'sharedreact/stores/generic/Type';
import FileSupport from 'sharedreact/utils/FileSupport';
import { translate } from 'sharedreact/utils/LanguageSupport';

import type FontFile from 'workspaces/launcher/data/FontFile';

function _renderTableActions (
  item: FontFile,
  row: number,
  col: number,
  allowMultiSelect: boolean,
  onRemove: (id: string) => void
) {
  if (allowMultiSelect) {
    return (
      <TableActions disabled>
        <TableAction
          id={'ae_button_launcher_fonts_' + row + '_remove'}
          className='esko_tableactionremove'
          disabled
        />
      </TableActions>
    );
  }
  return (
    <TableActions>
      <TableAction
        id={'ae_button_launcher_fonts_' + row + '_remove'}
        className='esko_tableactionremove'
        item={item.id}
        onClick={onRemove}
        title={translate('launcher.admin.fonts.tableaction.tooltip.remove')}
      />
    </TableActions>
  );
}

type Props = {
  language: string,
  fonts: Immutable.List<FontFile | null>,
  selection: Immutable.Set<string>,
  allowMultiSelect: boolean,
  sortOrder: SortOrder,

  setVisibleRange: (visibleRange: RangeType) => void,
  onSortOrderChange: (sortOrder: SortOrder) => void,
  onItemSelect: (id: string) => void,
  onRemove: (id: string) => void
};

class FontsTable extends React.Component<Props> {
  override render (): React.ReactNode {
    const {
      language, // eslint-disable-line no-unused-vars
      fonts,
      selection,
      allowMultiSelect,
      sortOrder,
      setVisibleRange,
      onSortOrderChange,
      onItemSelect,
      onRemove
    } = this.props;

    const tableColumns: Immutable.List<TableColumn<FontFile>> = Immutable.List([ {
      title: translate('launcher.fonts.table.name'),
      width: '90%',
      renderCell: (item: FontFile, row: number, col: number) => item.name,
      sortOrderKeyword: 'name',
      selectable: false,
      movable: true,
      name: 'name'
    }, {
      title: translate('common.general.actions'),
      width: '10%',
      minimumWidth: '100px',
      renderCell: (item: FontFile, row: number, col: number) => _renderTableActions(item, row, col, allowMultiSelect, onRemove),
      selectable: false,
      movable: true,
      name: 'actions'
    }, {
      title: translate('launcher.fonts.table.moddate'),
      width: '35%',
      renderCell: (item: FontFile, row: number, col: number) =>
      (
        (item.modificationDate != null && moment.isMoment(item.modificationDate))
          ? item.modificationDate.locale(moment.locale()).format('LLL') : ''
      ),
      sortOrderKeyword: 'modificationdate',
      selectable: true,
      movable: true,
      name: 'modificationDate'
    }, {
      title: translate('launcher.fonts.table.filesize'),
      width: '15%',
      alignRight: true,
      renderCell: (item: FontFile, row: number, col: number) => (
        FileSupport.formatFileSize(item.fileSize)
      ),
      sortOrderKeyword: 'size',
      selectable: true,
      movable: true,
      name: 'fileSize'
    }]);

    return (
      <TableContainer<FontFile>
        id='launcher_fonts_table'
        tableName='FontsTable'
        rowData={fonts}
        tableColumns={tableColumns}
        selection={selection}
        showSelection={allowMultiSelect}
        sortOrder={sortOrder}
        setVisibleRange={setVisibleRange}
        onSortOrderChange={onSortOrderChange}
        onItemSelect={onItemSelect}
      />
    );
  }
}

export default FontsTable;
